import { getAnalytics } from "firebase/analytics";
import { app } from "./app";

const analytics = getAnalytics(app);

export { analytics };
